import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.75rem 0 0 0;
`;
